import {Box} from "@mui/system";
import {COLORS} from "../../../../ui/Theme";
import {Card, CardContent, Skeleton, Typography} from "@mui/material";
import {useStrategiesContext} from "../../../../context/derivatives/strategies/DerivativesStrategiesContext";
import {useNavigate, useSearchParams} from "react-router-dom";
import Grid2 from "@mui/material/Unstable_Grid2";
import useResponsive from "../../../../components/hooks/useResponsive";
import {FaThermometerEmpty, FaThermometerFull, FaThermometerHalf,} from "react-icons/fa";
import NotFound from "../../../../components/notfound/NotFound";

const DerivativesStrategiesPreview = ({url}) => {
    const {strategies, setSelectedRiskLevel, setSelectedStrategy} =
        useStrategiesContext();

    const {isSm} = useResponsive();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const handleNavigateToStrategies = (selectedStrategy, selectedRiskLevel) => {
        navigate(url);
        setSearchParams({
            risk_level: selectedRiskLevel.key,
            strategy: selectedStrategy.key,
        });
        setSelectedStrategy(selectedStrategy);
        setSelectedRiskLevel(selectedRiskLevel);
    };

    return (
        <Box>
            <Typography
                sx={{
                    color: COLORS.BLACK,
                    fontSize: "16px",
                    fontWeight: 700,
                    marginBottom: "14px",
                }}
            >
                استراتژی‌ها
            </Typography>
            <Grid2 container spacing="14px" sx={{paddingBottom: !isSm && "70px"}}>
                {/*CREATE THREE BIG CARDS*/}
                {strategies.map((strategy, index) => (
                    <Grid2 key={index} xs={12} lg={6} xl={4}>
                        <Card>
                            <CardContent
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "14px",
                                    width: "100%",
                                    height: "56vh",
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        fontSize: "16px",
                                        fontWeight: 700,
                                    }}
                                >
                                    <Typography sx={{fontSize: "16px", fontWeight: 700}}>
                                        {strategy.name}
                                    </Typography>
                                    {strategy.name === "بدون ریسک" ? (
                                        <FaThermometerEmpty
                                            style={{color: COLORS.GREEN, fontSize: "20px"}}
                                        />
                                    ) : strategy.name === "کم ریسک" ? (
                                        <FaThermometerHalf
                                            style={{color: COLORS.ORANGE, fontSize: "20px"}}
                                        />
                                    ) : (
                                        <FaThermometerFull
                                            style={{color: COLORS.RED, fontSize: "20px"}}
                                        />
                                    )}
                                </Box>
                                <Box
                                    sx={{
                                        height: "100vh",
                                        overflow: "auto",
                                        scrollbarWidth: "none",
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "10px",
                                        p: "10px",
                                        borderRadius: "15px",
                                        border: `1px solid ${COLORS.SOFTGRAY}`,
                                    }}
                                >
                                    {
                                        strategy.data?.isValidating ? (
                                            <>
                                                <Box
                                                    sx={{
                                                        width: "100%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        gap: "20px",
                                                        padding: "14px 20px",
                                                        backgroundColor: COLORS.WHITE,
                                                        borderRadius: "18px",
                                                        border: "2px solid #EEEEEE",
                                                        minHeight: "170px",
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            width: "100%",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                        }}
                                                    >
                                                        <Skeleton width="75px" height="30px" variant="text"/>
                                                        <Skeleton width="200px" height="18px" variant="text"/>
                                                        <Skeleton width="65px" height="21px" variant="text"/>
                                                    </Box>
                                                    <Skeleton width="200px" height="88px" variant="rounded"/>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        width: "100%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        gap: "20px",
                                                        padding: "14px 20px",
                                                        backgroundColor: COLORS.WHITE,
                                                        borderRadius: "18px",
                                                        border: "2px solid #EEEEEE",
                                                        minHeight: "170px",
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            width: "100%",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                        }}
                                                    >
                                                        <Skeleton width="75px" height="30px" variant="text"/>
                                                        <Skeleton width="200px" height="18px" variant="text"/>
                                                        <Skeleton width="65px" height="21px" variant="text"/>
                                                    </Box>
                                                    <Skeleton width="200px" height="88px" variant="rounded"/>
                                                </Box>
                                            </>
                                        ) : (
                                            strategy.data?.data?.length > 0 ? (
                                                strategy.data.data.map((item, idx) => (
                                                    <Box
                                                        key={idx}
                                                        onClick={() => handleNavigateToStrategies(item, strategy)}
                                                        sx={{
                                                            width: "100%",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                            gap: "20px",
                                                            padding: {xs: "10px", md: "14px 20px"},
                                                            backgroundColor: COLORS.WHITE,
                                                            borderRadius: "18px",
                                                            border: "2px solid #EEEEEE",
                                                            minHeight: "170px",
                                                            cursor: "pointer",
                                                            transition: "all 0.1s ease",
                                                            ":hover": {
                                                                border: `2px solid ${COLORS.BLUE}`,
                                                            },
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "flex-start",
                                                                justifyContent: "flex-start",
                                                                flexDirection: "column",
                                                            }}
                                                        >
                                                            <Typography
                                                                sx={{
                                                                    fontSize: "20px",
                                                                    fontWeight: 700,
                                                                    color: COLORS.BLACK,
                                                                    marginBottom: "8px",
                                                                }}
                                                            >
                                                                {item.name}
                                                            </Typography>
                                                            <Typography
                                                                sx={{
                                                                    display: {xs: "none", md: "block"},
                                                                    fontSize: "12px",
                                                                    fontWeight: 400,
                                                                    color: COLORS.GRAY,
                                                                    marginBottom: "10px",
                                                                }}
                                                            >
                                                                {item.desc}
                                                            </Typography>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: "14px",
                                                                    fontWeight: 400,
                                                                    color: COLORS.GRAY,
                                                                }}
                                                            >
                                                                {item.profit}
                                                            </Typography>
                                                        </Box>
                                                        <img
                                                            width={isSm ? "139px" : "110px"}
                                                            src={item.schema}
                                                            alt={item.name}
                                                        />
                                                    </Box>
                                                ))
                                            ) : (
                                                <NotFound/>
                                            )
                                        )
                                    }
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid2>
                ))}
            </Grid2>
        </Box>
    );
};

export default DerivativesStrategiesPreview;
